import Swiper from 'swiper';
import {BaseSlider} from "./BaseSlider";

export class NewsTeaserSlider extends BaseSlider {
    constructor() {
        super('.swiper-news-teaser');

        this.initSlider();
    }
}